import React, { FunctionComponent } from 'react';
import { Header } from '@ds/ui';
import styled from '@emotion/styled';
import { ConditionalChildren } from 'layouts';
import { Branding } from 'store/types/branding';
import OliveImages from '@olive/images';

export const HeaderLeftContainer = styled.div`
    height: 63px;

    & > div {
        min-width: 143px;
    }

    .App-logo {/* PHONE-859 fix logo overflow */
        max-width: 120px;
        max-height: 90px;
        width: auto;
        height: auto;
    }
`;
export interface ApplicationLayoutHeaderProps {
    branding: Branding;
}
const ApplicationLayoutHeader: FunctionComponent<ApplicationLayoutHeaderProps> = ({ branding }) => (
    <>
        <Header fullWidth>
            <HeaderLeftContainer>
                <Header.Left>
                    <ConditionalChildren
                        condition={Boolean(branding.logo)}
                        fallback={<img data-qa="header-logo-img" alt="Docusign" className="App-logo" src={OliveImages.dsLogoDefault} />}
                    >
                        <img data-qa="header-logo-branding" alt={branding.companyName || ''} className="App-logo" src={`data:image/jpeg;base64,${branding.logo}`} />
                    </ConditionalChildren>
                </Header.Left>
            </HeaderLeftContainer>
        </Header>
    </>
);
export default ApplicationLayoutHeader;
